(function () {
  function getFocusableElements(container) {
    if (!container) return [];
    return Array.from(container.querySelectorAll(
      'a[href], area[href], input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => element.offsetParent !== null);
  }

  function initSupplementPopup(root) {
    // The reusable component owns its complete dialog and focus behavior.
    if (document.querySelector('[data-supplement-facts]')) return;

    const popup = root.querySelector?.('.iip-popup-inner-container') || document.querySelector('.iip-popup-inner-container');
    const popupTrigger = root.querySelector?.('[data-supplement-facts-trigger]') || document.querySelector('[data-supplement-facts-trigger]');
    const closeButton = root.querySelector?.('.iip-close-popup') || document.querySelector('.iip-close-popup');

    if (!popup || !popupTrigger || popup.dataset.adaPopupInitialized === 'true') return;
    popup.dataset.adaPopupInitialized = 'true';

    function closePopup() {
      popup.style.display = 'none';
      popupTrigger.focus();
    }

    popup.addEventListener('keydown', function handleTrapFocus(event) {
      const focusableEls = getFocusableElements(popup);
      const firstEl = focusableEls[0];
      const lastEl = focusableEls[focusableEls.length - 1];

      if (event.key === 'Tab') {
        if (!firstEl || !lastEl) return;

        if (event.shiftKey && document.activeElement === firstEl) {
          event.preventDefault();
          lastEl.focus();
        } else if (!event.shiftKey && document.activeElement === lastEl) {
          event.preventDefault();
          firstEl.focus();
        }
      }

      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        closePopup();
      }
    });

    popupTrigger.addEventListener('click', function () {
      popup.style.display = '';
      const firstEl = getFocusableElements(popup)[0];
      if (firstEl) firstEl.focus();
    });

    if (closeButton && closeButton.dataset.adaCloseInitialized !== 'true') {
      closeButton.dataset.adaCloseInitialized = 'true';
      closeButton.addEventListener('click', closePopup);
      closeButton.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
          event.preventDefault();
          closeButton.click();
        }
      });
    }
  }

  function initBannerMedia(root) {
    root.querySelectorAll?.('.banner__media').forEach((bannerMedia) => {
      if (bannerMedia.dataset.adaBannerMediaInitialized === 'true') return;
      const video = bannerMedia.querySelector('video');
      if (!video) return;

      bannerMedia.dataset.adaBannerMediaInitialized = 'true';

      const playPauseButton = document.createElement('button');
      playPauseButton.type = 'button';
      playPauseButton.className = 'play-pause-btn';
      playPauseButton.textContent = video.paused ? 'Play' : 'Pause';
      bannerMedia.prepend(playPauseButton);

      playPauseButton.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          playPauseButton.textContent = 'Pause';
        } else {
          video.pause();
          playPauseButton.textContent = 'Play';
        }
      });
    });
  }

  function initBenefitTabs(root) {
    const tabLists = new Set(
      Array.from(root.querySelectorAll?.('.hw__benefit-tab--links') || [])
    );

    tabLists.forEach((tabList) => {
      if (tabList.dataset.adaTabsInitialized === 'true') return;
      const tabs = Array.from(tabList.querySelectorAll('a'));
      const sectionRoot = tabList.closest('.shopify-section') || document;
      const panels = Array.from(sectionRoot.querySelectorAll('.hw__benefit-tab--content'));

      if (!tabs.length || !panels.length) return;
      tabList.dataset.adaTabsInitialized = 'true';

      function activateTab(tab) {
        if (!tab) return;

        tabs.forEach((tabElement) => {
          tabElement.setAttribute('aria-selected', 'false');
          tabElement.parentElement?.classList.remove('active');
        });

        panels.forEach((panelElement) => {
          panelElement.hidden = true;
          panelElement.classList.remove('active');
        });

        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');
        tab.parentElement?.classList.add('active');

        const targetId = tab.getAttribute('href')?.substring(1);
        const panel = targetId ? document.getElementById(targetId) : null;
        if (!panel) return;

        panel.hidden = false;
        panel.classList.add('active');
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', function (event) {
          event.preventDefault();
          activateTab(tab);
        });

        tab.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activateTab(tab);
          }
        });
      });

      activateTab(tabs.find((tab) => tab.parentElement?.classList.contains('active')) || tabs[0]);
    });
  }

  function initAdaEnhancements(root = document) {
    initSupplementPopup(root);
    initBannerMedia(root);
    initBenefitTabs(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAdaEnhancements(document), { once: true });
  } else {
    initAdaEnhancements(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAdaEnhancements(event.target);
  });
})();
